<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/12w6F4e/tc-custom/9780795345548.jpg?1718183454639" alt="This image is the cover for the book Voice Crying in the Wilderness"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Voice Crying in the Wilderness
      </h1>
      <p class="bookDescription body article font2">
        <b>Thoughts on nature, politics, love, and much more—from the environmentalist and author of such classics as <i>Desert Solitaire</i> and <i>The Monkey Wrench Gang</i>.</b><br/>  <br/> Finished just two weeks before his death, <i>A Voice Crying in the Wilderness</i> is a collection of Edward Abbey’s observations, both bitingly witty and inspirational, on a wide range of topics—from philosophy and writing to music, money, sex, and sports.<br/>  <br/> Abbey chose each passage himself from his own journals and previous writings—and warns us in his typical humorous style that some of the notes “may be unconscious plagiarisms from the great and dead (never steal from the living and mediocre).”<br/>  <br/> Abbey’s last wish was to be buried in an unmarked grave somewhere out in the vast desert he loved so much. This book is an enduring signal from that desert, through the words of one of the singular American thinkers of our times.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Edward Abbey
      </h2>
      
      <p class="authorDescription body article">&amp;lt;p&amp;gt;Edward Abbey spent most of his life in the American Southwest. He was the author of numerous works of fiction and nonfiction, including the celebrated &amp;lt;em&amp;gt;Desert Solitaire&amp;lt;/em&amp;gt;, which decried the waste of America&amp;#8217;s wilderness, and the novel &amp;lt;em&amp;gt;The Monkey Wrench Gang&amp;lt;/em&amp;gt;, the title of which is still in use today to describe groups that purposefully sabotage projects and entities that degrade the environment. Abbey was also one of the country&amp;#8217;s foremost defenders of the natural environment. He died in 1989.&amp;lt;/p&amp;gt;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      RosettaBooks, LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6ac468df